<template>
  <m-dialog ref="timespentDlg" title="Dashboard Timespent" :btnsave="false">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-card>
          <v-card-title class="primary--text title mb-0 pb-0"
            ><i class="font-weight-bold">Time Spent</i>&nbsp; (Keterangan Waktu yang dibutuhkan)</v-card-title
          >
          <v-row class="mx-3 mt-3" v-if="items.length > 0">
            <v-col cols="2" align="center">
              <v-avatar width="75" height="75" :size="75" color="secondary2">
                <v-icon color="secondary">mdi-google-classroom</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="7">
              <p class="font-weight-bold mb-0 pb-0 body-1">DIKLAT {{ items[0].kelas.diklat.nama }}</p>
              <p class="font-weight-light mb-0 pb-0">KELAS {{ items[0].kelas.nama }}</p>
              <p class="font-weight-light orange--text mb-0 pb-0 caption">Diperbarui pada {{ lastupdate }}</p>
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="3" xl="3">
              <m-button
                text="Unduh"
                icon="mdi-download"
                :large="false"
                action="toDownload"
                color="success"
                dark
                @toDownload="toDownload()"
              ></m-button>
            </v-col>
            <v-col cols="12">
              <v-data-table
                class="elevation-0 fix_td"
                :headers="headers"
                :items="items"
                :items-per-page="5"
              ></v-data-table>
            </v-col>
          </v-row>
          <m-alert
            v-else
            show
            title="Informasi"
            info="Data timespent tidak tersedia atau dalam proses singkronisasi"
          ></m-alert>
        </v-card>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
const lc = window.localStorage;
import moment from "moment";
const TOKEN = "token";
export default {
  components: {},

  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      kelas_modul_id: null,
      headers: [
        { text: "Fitur LMS", align: "left", value: "fitur_lms" },
        { text: "Jam Pelajaran", align: "left", value: "menit_pelajaran" },
        { text: "Porsi Jam", align: "left", value: "menit_porsi" },
        { text: "Metode", align: "left", value: "metode" },
        { text: "Ketercapaian", align: "left", value: "ketercapaian" },
        { text: "Timespend Menit", value: "menit_timespend", sortable: false }
      ]
    };
  },
  computed: {
    lastupdate() {
      if (this.items.length > 0) {
        return moment(this.items[0].captured_at).format("DD/MM/YYYY HH:mm") + " WIB";
      }
    }
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.load(obj);
      this.kelas_modul_id = obj.id;
      let x = this.$refs.timespentDlg.open();
      this.$validator.reset();
      return x;
    },
    load(obj) {
      return this.$store
        .dispatch("kelas/getTimespent", {
          kelas_modul_id: obj.id,
          instansi_id: this.instansi_id
        })
        .then(res => {
          this.items = res;
        })
        .catch(e => e);
    },
    toDownload() {
      var token = lc.getItem(TOKEN);
      this.loading = true;
      return this.$store
        .dispatch("kelas/unduhTimespent", {
          instansi_id: this.current_instansi.id,
          kelas_modul_id: this.kelas_modul_id,
          token: token
        })
        .then(res => {
          if (res) {
            this.loading = false;
            this.$info("Timespent berhasil diunduh.");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$error("Timespent gagal diunduh.");
        });
    }
  },
  watch: {}
};
</script>
